import { ValueProvider } from '@juvare/common-form-ui/ValueProvider';
import { buildValueProvider } from '@juvare/platform-sdk-react/ui/features/classifiers';
import { getAppName } from '@juvare/platform-sdk-react/ui/utils';
import { DepartmentColumns, departmentEntityName } from '../../../../backend/config/classifiers';

export function useDepartmentValueProvider(): ValueProvider {
    return buildValueProvider<DepartmentColumns>(getAppName(), 'department', 'Department', false, departmentEntityName, (client) =>
        client
            .storageList({
                filter: [{ column: 'status', op: '=', value: 'active' }],
                orderBy: [{ column: 'name' }],
            })
            .then((result) => result.rows.map((row) => ({ value: row.id, label: row.columns.name || '' }))),
    );
}
